import axios from "../../util/axios";

export default {
    /** 查询列表 */
    queryList: (data) => axios.get({url: "/wx/quotation/xbot/queryList", data}),
    /** 删除 */
    refreshStatus: (guid) => axios.get({url: "/wx/quotation/xbot/refreshStatus", data: {guid}}),
    /** 保存 */
    addEmployee: (data) => axios.post({url: "/wx/quotation/xbot/addEmployee", data}),
    // 退出登录
    logoutXbot:  (guid) => axios.get({url: "/wx/quotation/xbot/logoutXbot", data: {guid}}),
    /** 获取登录二维码 */
    getLoginQrCode: (guid) => axios.get({url: "/wx/quotation/xbot/getLoginQrCode", data: {guid}}),
    /** 获取登录状态 */
    getLoginStatus: (guid) => axios.get({url: "/wx/quotation/xbot/getLoginStatus", data: {guid}}),
    /**设置回调地址*/
    setNotify: (data) => axios.post({url: "/wx/quotation/xbot/setNotify", data}),
    /**设置昵称*/
    setNickName: (data) => axios.post({url: "/wx/quotation/xbot/setNickName", data}),
    /**删除员工*/
    deleteEmployee: (id) => axios.del({url: "/wx/quotation/xbot/deleteEmployee", data: {id}}),
    /**保存员工管理员*/
    saveEmployeeManager: (data) => axios.get({url: "/wx/quotation/xbot/saveEmployeeManager", data}),

}